<template>
  <kst-print class="kst-hppadj-print" :error="error" :loading="isLoading">
    <template #header>
      <div class="columns is-mobile">
        <div class="column is-half">
          <Company :data="companyData"/>
        </div>
        <div class="column is-half">
          <div class="is-size-3">{{ title }}</div>
        </div>
      </div>

      <div class="columns is-mobile">
        <div class="column">
          <Details :data="data"/>
        </div>
      </div>
    </template>

    <Items class="mt-4" :data="data" :items="data.Items"/>
    <Total class="mt-4" :data="data" :items="data.Items" />
  </kst-print>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";
import Info from "../HppAdjInfo.js";
import Model from "../HppAdjModel.js";
import Services from "../HppAdjServices.js";

import Company from "./HppAdjPrintDetails_Company";
import Details from "./HppAdjPrintDetails_Details";
import Items from "./HppAdjPrintDetails_Items";
import Total from "./HppAdjPrintDetails_Total";

export default {
  mixins: [AxiosMixin, RouterMixin],
  components: {
    Company,
    Details,
    Items,
    Total
  },
  data: () => ({
    data: {},
    companyData: {},
    isLoading: false,
    // error
    error: null
  }),
  computed: {
    title() {
      return Model.Module.FullName;
    }
  },
  created(){
    this.init();
  },
  methods: {
    init() {
      const id = this.getUrlParam(this.$kst.Enum.Param.ID);
      this.error = null;

      if (!id) {
        this.error = Info.Message.PrintDetails_ParamIncomplete;
        return;
      }

      this.data = {};
      this.companyData = {};

      this.initLoad(id);
    },
    initLoad(id) {
      this.isLoading = true;
      this.error = null;

      this.loadDetailsData(id);
    },
    initLoad_End() {
      this.isLoading = false;
    },

    loadDetailsData(id) {
      const config = Services.getHppAdjDetailsData(id, { withcompany: 1 });
      this.runAxios(config, null,
        this.loadDetailsData_Success,
        this.loadDetailsData_Error,
        this.loadDetailsData_Invalid
      );
    },
    loadDetailsData_Success(data) {
      this.data = data.Details;
      this.companyData = data.CompanyDetails;
      this.initLoad_End();
    },
    loadDetailsData_Error(message) {
      this.error = message;
      this.initLoad_End();
    },
    loadDetailsData_Invalid(message) {
      this.error = message;
      this.initLoad_End();
    }
  }
}
</script>